import IndirectSelect from './../lq-form-element-maker/IndirectSelect'
export default IndirectSelect.extend({
    name: 'lq-v-select',
})